import {Component} from '@angular/core';

@Component({
    selector: 'emm-operations-right-header',
    templateUrl: './operations-right-header.html',
    styleUrl: './operations-right-header.scss',
    standalone: false
})
export class OperationsRightHeader {

}
